module.exports = __webpack_public_path__ + "img/samy-halim-martin-day.12d11c9.jpg";